export default __webpack_public_path__ + "static/media/hotel-out-7.56e83968.jpg";